import React from 'react';

const CTA: React.FC = () => {
  return (
    <section className="py-32 px-4 sm:px-6 lg:px-8 section-dark relative overflow-hidden">
      {/* Background Effects - Corporate Colors */}
      <div className="floating-orb w-96 h-96 bg-blue-600 top-20 left-20"></div>
      <div className="floating-orb w-80 h-80 bg-cyan-600 bottom-20 right-20"></div>
      
      <div className="relative z-10 max-w-7xl mx-auto">
        <div className="glass-card rounded-3xl p-12 lg:p-20 text-center relative overflow-hidden">
          {/* Background Pattern - Corporate Colors */}
          <div className="absolute inset-0 bg-gradient-to-br from-blue-600/8 via-slate-700/8 to-cyan-600/8"></div>
          <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-blue-600 via-blue-500 to-cyan-500"></div>
          
          <div className="relative z-10">
            <div className="inline-flex items-center px-6 py-3 rounded-full glass-effect text-white text-sm font-medium mb-8">
              <span className="gradient-text font-semibold">Ready to Scale?</span>
            </div>
            
            <h2 className="text-5xl md:text-7xl font-black text-white mb-8 leading-tight">
              Ready to Transform Your{' '}
              <span className="gradient-text">Business?</span>
            </h2>
            <p className="text-xl md:text-2xl text-gray-300 mb-12 max-w-4xl mx-auto leading-relaxed">
              Join industry leaders already using Crel AI to deliver exceptional customer experiences. 
              Start your enterprise trial today and see measurable results in weeks, not months.
            </p>
            
            <div className="flex flex-col sm:flex-row gap-6 justify-center items-center mb-12">
              <button className="btn-primary text-lg font-semibold group">
                <span className="relative z-10">Start Enterprise Trial</span>
                <div className="absolute inset-0 bg-gradient-to-r from-blue-700 via-blue-600 to-cyan-600 opacity-0 group-hover:opacity-100 transition-opacity duration-500 rounded-2xl"></div>
              </button>
              <button className="btn-secondary text-lg font-semibold">
                Schedule Consultation
              </button>
            </div>
            
            <div className="flex flex-col sm:flex-row items-center justify-center gap-8 text-sm text-gray-400">
              <div className="flex items-center">
                <svg className="w-5 h-5 mr-2 text-blue-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                </svg>
                30-day enterprise trial
              </div>
              <div className="flex items-center">
                <svg className="w-5 h-5 mr-2 text-blue-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                </svg>
                Dedicated support team
              </div>
              <div className="flex items-center">
                <svg className="w-5 h-5 mr-2 text-blue-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                </svg>
                Custom implementation
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTA; 